import { RadioFormFieldOption } from "../common/components/FormFields";
import { ListOption } from "../common/api/Interfaces/listOption";

export function getGroceryStoreOptionsForCommunity(
  communities: ListOption[] | undefined,
  communityId: string,
): RadioFormFieldOption[] {
  const communityName = communities?.find(
    (community) => community.id === parseInt(communityId),
  )?.name;

  const STANTON = { value: "1", text: "Stanton" };
  const COOP = { value: "2", text: "Co-op" };
  const NORTHERN = { value: "3", text: "Northern Store" };
  const OTHER = { value: "4", text: "Other" };
  const IKAHUK_COOP = { value: "5", text: "Ikahuk Co-op" };
  const UKUKHAKTOK_COOP = { value: "6", text: "Ulukhaktok Co-op" };

  let result;
  switch (communityName) {
    case "Aklavik":
      result = [STANTON, NORTHERN];
      break;
    case "Inuvik":
      result = [STANTON, NORTHERN];
      break;
    case "Paulatuk":
      result = [STANTON, NORTHERN];
      break;
    case "Sachs Harbour":
      result = [STANTON, IKAHUK_COOP];
      break;
    case "Tuktoyaktuk":
      result = [STANTON, NORTHERN];
      break;
    case "Ulukhaktok":
      result = [STANTON, UKUKHAKTOK_COOP, NORTHERN];
      break;
    case "Outside ISR":
      result = [STANTON, NORTHERN, IKAHUK_COOP, UKUKHAKTOK_COOP];
      break;
    default:
      result = [STANTON, NORTHERN];
      break;
  }

  return result;
}

export function getGasStoreOptionsForCommunity(
  communities: ListOption[] | undefined,
  communityId: string,
): RadioFormFieldOption[] {
  const communityName = communities?.find(
    (community) => community.id === parseInt(communityId),
  )?.name;

  const NORTHWIND_PETROLEUM = { value: "1", text: "Northwind Petroleum" };
  const BOBS_GAS_BAR = { value: "2", text: "Bob's Gas Bar" };
  const COOP = { value: "3", text: "Co-op" };
  const NORTHERN = { value: "4", text: "Northern" };
  const ATBA = { value: "5", text: "Atba" };
  const ETG_BAS_BAR = { value: "6", text: "EGT Petroleum" };
  const OTHER = { value: "7", text: "Other" };
  const ARCTIC_PETROLEUM = { value: "8", text: "Arctic Petroleum " };
  const IKAHUK_COOP = { value: "9", text: "Ikahuk Co-op" };
  const ULUKHAKTOK_COOP = { value: "10", text: "Ulukhaktok Co-op" };
  const FUEL_SERVICES = { value: "11", text: "Fuel Services Division" };

  let result = [];
  switch (communityName) {
    case "Aklavik":
      result = [ARCTIC_PETROLEUM, BOBS_GAS_BAR];
      break;
    case "Inuvik":
      result = [NORTHWIND_PETROLEUM, BOBS_GAS_BAR];
      break;
    case "Paulatuk":
      return [FUEL_SERVICES];
    case "Sachs Harbour":
      result = [IKAHUK_COOP];
      break;
    case "Tuktoyaktuk":
      result = [ETG_BAS_BAR, BOBS_GAS_BAR];
      break;
    case "Ulukhaktok":
      result = [ULUKHAKTOK_COOP];
      break;
    case "Outside ISR":
      result = [
        NORTHWIND_PETROLEUM,
        BOBS_GAS_BAR,
        ETG_BAS_BAR,
        ARCTIC_PETROLEUM,
        IKAHUK_COOP,
        ULUKHAKTOK_COOP,
        FUEL_SERVICES,
      ];
      break;
    default:
      result = [ARCTIC_PETROLEUM, BOBS_GAS_BAR, NORTHWIND_PETROLEUM];
      break;
  }

  return result;
}
